import { action, makeObservable, observable } from 'mobx';

export class VersionsStore {
  @observable isOpened: boolean = false;
  @observable frontendV: string = window._env_.COMMIT_TAG
    ? String(window._env_.COMMIT_TAG)
    : `commit/${window._env_.COMMIT_SHORT_SHA ?? ''}`;
  @observable backendV: string = '';
  @observable cacheV: string = '';
  @observable orchestratorV: string = '';

  constructor() {
    makeObservable(this);
  }

  @action.bound
  setIsOpened(value: boolean): void {
    this.isOpened = value;
  }
}
